"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * We will use this enum, so we can mark assigned workout, so once client finish workout, it goes into history,
 * client can start again that workout from his history, that workout will be client generated, and it will be inside assigned workouts
 * collection. So on Home page we will fetch all assigned workouts that are not client generated
 */
var GeneratedBy;
(function (GeneratedBy) {
    GeneratedBy["CLIENT"] = "CLIENT";
    GeneratedBy["TRAINER"] = "TRAINER";
})(GeneratedBy || (GeneratedBy = {}));
exports.default = GeneratedBy;
//# sourceMappingURL=GeneratedBy.js.map